import { IOrder } from 'modules/ScrShopNew/store/slices/orders/types';

const ORDER_STORAGE_KEY = `order_${window.SITE_ID}`;
const CART_ID_STORAGE_KEY = `cartId_${window.SITE_ID}`;

export const getStoredCartId = () => {
  try {
    const stored = localStorage.getItem(CART_ID_STORAGE_KEY);

    return stored;
  } catch (error) {
    console.warn('Failed to parse cart from localStorage:', error);

    return null;
  }
};

export const saveCartIdToStorage = (cartId: string) => {
  try {
    localStorage.setItem(CART_ID_STORAGE_KEY, cartId);
  } catch (error) {
    console.warn('Failed to save cart to localStorage:', error);
  }
};

export const getOrderFromStorage = () => {
  try {
    const stored = localStorage.getItem(ORDER_STORAGE_KEY);

    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.warn('Failed to parse order from localStorage:', error);

    return null;
  }
};

export const saveOrderToStorage = (order: IOrder) => {
  try {
    localStorage.setItem(ORDER_STORAGE_KEY, JSON.stringify(order));
  } catch (error) {
    console.warn('Failed to save order to localStorage:', error);
  }
};

export const clearOrderStorage = () => {
  try {
    localStorage.removeItem(ORDER_STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear order storage from localStorage:', error);
  }
};
